import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getServiceProperty from '../../../../../helpers/getServiceProperty';
import Logo from '../../../../common/Logo';
import styles from './Header.scss';
import { subscriptionTypes } from 'rp-auth';

const { ESSENTIAL, ESSENTIAL_ULTIMATE } = subscriptionTypes;

function Header({ service, title }) {
  const serviceType = getServiceProperty(
    service.defaultSubscriptionInfo.subscriptionId,
    'type',
  ).toLowerCase();

  return (
    <div className={styles.root}>
      <Logo className={styles.logo} logoName="my-account-main" />
      <h3 className={classNames(styles.title, styles[serviceType])}>
        {title.replace(ESSENTIAL, ESSENTIAL_ULTIMATE)}
      </h3>
    </div>
  );
}

Header.propTypes = {
  service: PropTypes.shape({
    defaultSubscriptionInfo: PropTypes.shape({
      subscriptionId: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

export default Header;
